<template>
  <div>
    <div class="banner">
      <p class="container">
        <span class="up">关于我们</span>
        <span class="down">ABOUT US</span>
      </p>
    </div>
    <div class="path">
      <div class="container">当前位置： 首页 > 关于我们</div>
    </div>
    <section class="content container">
      <div class="intro">
        <h3>简介</h3>
        <span class="line"></span>
        <div class="tab-content">
          <div class="detail">
            <p>极客邦科技（隶属极客邦控股（北京）有限公司）是一家面向全球的 IT 知识服务平台。创立于 2007 年，提供媒体、会议、电商、培训、咨询、图书、社交等服务，总部设于北京。致力于让创新技术推动社会进步。十余年来，极客邦科技为数百万技术人，10,000+ 中国企业提供服务，业务遍布中国各城市，以及美国、法国、德国、荷兰、以色列、日本等国家。</p>
            <p style="margin-top:15px;">公司地址：北京市朝阳区叶青大厦北园5层</p>
            <p>公司电话：010-64738142</p>
          </div>
          <img alt="bg" src="https://static.geekbang.org/infoq/5aa26e58ae18f.png?imageView2/0/">
        </div>
      </div>

      <div class="kernel-values">
        <h3>核心价值观</h3>
        <span class="line"></span>
        <div class="detail">
          <div class="left">
            <img alt="photo" src="https://static.geekbang.org/infoq/5aa26e59553af.png?imageView2/0/">
            <div class="explain">
              <div class="wrapper">
                <h4>公开透明</h4>
                <h5>transparency</h5>
                <p>我们的工作流程、状态、期望值、个人感受、成功与失败都是公开和透明的</p>
                <p class="after">01 /</p>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="explain">
              <div class="wrapper">
                <h4>诚实正直</h4>
                <h5>integrity</h5>
                <p>我们说到做到，也只说自己做到的。我们创作读者信赖的内容，努力实现对读者、客户和团队成员彼此之间的承诺，为公司的最大利益而努力</p>
                <p class="after">02 /</p>
              </div>
            </div>
            <img alt="photo" src="https://static.geekbang.org/infoq/5aa26e59bcba2.png?imageView2/0/">
          </div>
          <div class="left">
            <img alt="photo" src="https://static.geekbang.org/infoq/5aa26e590525d.png?imageView2/0/">
            <div class="explain">
              <div class="wrapper">
                <h4>每日精进</h4>
                <h5>mastery</h5>
                <p>学习的脚步永不停止，持续提高自我，优化 流程和我们的公司</p>
                <p class="after">03 /</p>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="explain">
              <div class="wrappper">
                <h4>乐于服务</h4>
                <h5>service</h5>
                <p>享受为他人服务的乐趣，为我们的客户、读者和团队成员彼此提供优质的服务</p>
                <p class="after">04 /</p>
              </div>
            </div>
            <img alt="photo" src="https://static.geekbang.org/infoq/5aa26e5ad9e24.png?imageView2/0/">
          </div>
          <div class="left">
            <img alt="photo" src="https://static.geekbang.org/infoq/5aa26e5a13b5a.png?imageView2/0/">
            <div class="explain">
              <div class="wrapper">
                <h4>负责守诺</h4>
                <h5>accountability</h5>
                <p>为结果负责，我们尽力完成工作，认真对待我们做出的每一个承诺</p>
                <p class="after">05 /</p>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="explain">
              <div class="wrapper">
                <h4>创新敢为</h4>
                <h5>resourcefulness</h5>
                <p>努力找寻创造性的解决方案完成工作，时刻拥有“我能做”的态度</p>
                <p class="after">06 /</p>
              </div>
            </div>
            <img alt="photo" src="https://static.geekbang.org/infoq/5aa26e5a66049.png?imageView2/0/">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/variable.sass'

.banner
  background: url('https://static.geekbang.org/infoq/5aa239ac253f0.png')
  height: 185px
  background-size: cover
  display: flex
  align-items: center
  p
    color: #fff
    display: flex
    flex-direction: column
    // align-items: center
    justify-content: center
    font-weight: 700
    +mobile
      align-items: center
    span:first-child
      font-size: 35px
      margin-bottom: 20px
      +mobile
        font-size: 28px
        margin-bottom: 10px
    span:last-child
      font-size: 20px
      +mobile
        font-size: 15px
.path
  background-color: #eee
  +mobile
    padding: 1rem

.line
  display: block
  height: 1px
  background-color: #ccc
  margin: 20px 0
h3
  margin: 0 0 10px
  color: #3f3b3a
  font-size: 32px
  font-weight: 400
  line-height: 1em

.content
  padding-top: 50px
  padding-left: 1rem
  padding-right: 1rem
  .intro
    margin-bottom: 30px
    .tab-content
      display: flex
      +mobile
        flex-direction: column-reverse
      .detail
        float: left
        margin-right: 50px
        +mobile
          margin-right: 0
          text-align: justify
          margin-top: 15px
          font-size: 14px
        &::before
          content: ''
          margin-bottom: 25px
          border-top: 1px solid #b5b5b6
      img
        width: 320px

.left
  +mobile
   flex-direction: column
  .explain
    padding-left: 60px
    +mobile
      padding-left: 0
      padding-top: 30px

.right
  +mobile
   flex-direction: column-reverse
  .explain
    padding-right: 60px
    +mobile
      padding-right: 0
      padding-top: 30px

.left,.right
  display: flex
  justify-content: space-between
  margin-bottom: 50px
  .explain
    // flex-grow: 1
    display: flex
    justify-content: center
    align-items: center
    h4
      margin: 0 0 10px
      color: #3f3b3a
      font-size: 24px
      font-weight: 400
      line-height: 1em
    h5
      margin: 0 0 20px
      padding-bottom: 20px
      border-bottom: 1px solid #6a6c6b
      color: #6a6c6b
      font-size: 14px
      font-weight: 400
      line-height: 1em
      text-transform: uppercase
    p
      font-size: 14px
    .after
      color: #6a6c6b
      display: block
      margin-top: 20px
      font-size: 16px
  img
</style>
